import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Target, Zap, Shield } from 'lucide-react';
export function Hero() {
  const goToCheckout = () => {
    window.location.href = 'https://elitemindsetpress.com/cart/48021298053378:1';
  };
  return <section className="relative z-10 min-h-screen flex items-center pt-20 pb-12 px-6 md:px-12 max-w-7xl mx-auto" data-id="element-104">
      <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-105">
        {/* Left Column: Copy */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-2xl" data-id="element-106">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-tactical-surface border border-tactical-cyan/30 rounded-full mb-6" data-id="element-107">
            <div className="w-2 h-2 rounded-full bg-tactical-cyan animate-pulse" data-id="element-108"></div>
            <span className="text-tactical-cyan text-xs font-oswald tracking-widest" data-id="element-109">
              ELITE ACADEMY PROTOCOL
            </span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] mb-6 text-glow" data-id="element-110">
            THE ELITE STRIKER'S <br data-id="element-111" />
            <span className="text-tactical-cyan" data-id="element-112">IQ MAP</span>
          </h1>

          <h2 className="text-xl md:text-2xl text-slate-300 font-inter font-light leading-relaxed mb-8" data-id="element-113">
            The Hidden Protocol for the{' '}
            <span className="font-semibold text-white" data-id="element-114">"Invisible Second"</span>
          </h2>

          <p className="text-slate-400 text-lg mb-10 leading-relaxed" data-id="element-115">
            Is your child technically gifted but playing "too slow"? Give them
            the cognitive scanning secrets that elite European academies use to
            turn talented players into untouchable predators.
          </p>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-116">
            <Button onClick={goToCheckout} className="w-full sm:w-auto" data-id="element-117">
              GET THE IQ MAP NOW
            </Button>
          </div>

          <div className="mt-8 flex items-center gap-6 text-sm text-slate-400 font-inter" data-id="element-118">
            <div className="flex items-center gap-2" data-id="element-119">
              <Zap className="w-4 h-4 text-tactical-cyan" data-id="element-120" /> Instant Access
            </div>
            <div className="flex items-center gap-2" data-id="element-121">
              <Target className="w-4 h-4 text-tactical-cyan" data-id="element-122" /> Ages 10-16
            </div>
            <div className="flex items-center gap-2" data-id="element-123">
              <Shield className="w-4 h-4 text-tactical-cyan" data-id="element-124" /> Safe Checkout
            </div>
          </div>
        </motion.div>

        {/* Right Column: Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative" data-id="element-125">
          {/* Decorative background glow for image */}
          <div className="absolute inset-0 bg-tactical-cyan/20 blur-[100px] rounded-full" data-id="element-126"></div>

          <div className="relative rounded-2xl overflow-hidden border border-tactical-surface2 bg-tactical-surface p-2 box-glow" data-id="element-127">
            <img src="https://cdn.magicpatterns.com/uploads/kqeFWnwtzdpNiNyns3hmVW/private_openrouter-generated-image-1781542753179.png" alt="The Elite Striker's IQ Map on Tablet" className="w-full h-auto rounded-xl object-cover" data-id="element-128" />

            {/* Overlay scanning line effect */}
            <motion.div className="absolute top-0 left-0 w-full h-1 bg-tactical-cyan/50 shadow-[0_0_15px_rgba(34,211,238,0.8)]" animate={{
            top: ['0%', '100%', '0%']
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-129" />
          </div>
        </motion.div>
      </div>
    </section>;
}